$(document).ready(function () {

  /*lazyload*/
  var myLazyLoad = new LazyLoad({
    elements_selector: ".lazy"
  });

  /* responsive styles */
  $(function () {
    var mobile = false;
    var tablet = false;
    var desktop = false;
    function checkWidth() {
      var viewportWidth = window.viewportSize.getWidth();
      if (viewportWidth <= 620) {
        if (!mobile) {
          $('div.header p.search').insertAfter('div.header .nav');
          $('.flexslider ul li a').not('.flexslider ul.flex-direction-nav li a').contents().unwrap();
          $('div.sweeps-banner').insertBefore('div.header');
          $('h5#registry-footer-link').insertAfter('p.support');
        }
        mobile = true;
        desktop = false;
        tablet = false;
      } else if (viewportWidth >= 621 && viewportWidth <= 768) {
        if (!tablet) {
          $('div.header p.search').insertAfter('div.header .nav');
          $('div.sweeps-banner').insertBefore('div.header');
          $('h5#registry-footer-link').prependTo('div.registry-foot-link');
        }
        mobile = false;
        desktop = false;
        tablet = true;
      } else {
        if (!desktop) {
          $('div.header p.search').insertBefore('div.header .utilities .shop-cart');
          $('div.sweeps-banner').insertBefore('div.header');
          $('h5#registry-footer-link').prependTo('div.registry-foot-link');
        }
        mobile = false;
        desktop = true;
        tablet = false;
      }
    }
    checkWidth();
    $(window).on('resize', checkWidth);
  });
  /* end responsive styles */

  //Product Page Item description collapse and tabs
  $(function () {
    const $tabLinksWrap = $('#tabs > .tab-links');
    const $tabFirstBtn = $tabLinksWrap.find('button').eq(0);

    $("#tabs > div").hide();
    $("#tabs > div:first").show();
    $tabFirstBtn.addClass('active');

    $tabLinksWrap.on('mouseenter', 'button', function () {
      const $this = $(this);
      const $sibling = $this.siblings();

      $sibling.removeClass('active').attr({
        'tabindex': '-1',
        'aria-selected': 'false'
      });

      $this.addClass('active').attr({
        'tabindex': '0',
        'aria-selected': 'true'
      });

      var currentTab = $this.attr('aria-controls');
      $("#tabs > div").hide();
      $(`#${currentTab}`).show();

      return false;
    });
  });

  // GIFT REGISTRY
  // Pinned Add to Registry
  $(function () {
    $(window).on('scroll', function () {
      if ($(window).scrollTop() >= (($(document).height() - $(window).height()) - $('.footer').innerHeight()) + parseInt($('.footer').css('padding-top'), 5)) {
        $(".reg-recmd .reg-list .reg-cta").css({ position: "static" }).removeClass("ctaFixed");
      } else {
        $(".reg-recmd .reg-list .reg-cta").css({ position: "fixed" }).addClass("ctaFixed");
      }
    });
  });
  // End Pinned Add to Registry

  $(".tab_content").hide();
  $(".tab_content:first").show();
  $("ul.tabs li").on('mouseenter', function () {
    $(".tab_content").hide();
    var activeTab = $(this).attr("rel");
    $("#" + activeTab).fadeIn();
    $("ul.tabs li").removeClass("active");
    $(this).addClass("active");
    $(".tab_drawer_heading").removeClass("d_active");
    $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");
  });
  $(".tab_drawer_heading").on('mouseenter', function () {
    $(".tab_content").hide();
    var d_activeTab = $(this).attr("rel");
    $("#" + d_activeTab).fadeIn();
    $(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");
    $("ul.tabs li").removeClass("active");
    $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
  });
  $('ul.tabs li').last().addClass("tab_last");
  // End Registry 

  //Equalize Columns
  $(function () {
    var equalheight = function (container) {
      var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el, topPosition = 0;
      $(container).each(function () {
        $el = $(this);
        $($el).height('auto')
        var topPostion = $el.position().top;
        if (currentRowStart != topPostion) {
          for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
          }
          rowDivs.length = 0;
          currentRowStart = topPostion;
          currentTallest = $el.height();
          rowDivs.push($el);
        } else {
          rowDivs.push($el);
          currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest);
        }
      });
    }
    $(window).on('load', function () {
      equalheight('.sub-hp .col');
      equalheight('.sub-hp3 .col2');
      equalheight('.item-wrap .item');
      equalheight('.pgProduct .similar-items ul li');
    });
    $(window).on('resize', function () {
      equalheight('.sub-hp .col');
      equalheight('.sub-hp3 .col2');
      equalheight('.item-wrap .item');
      equalheight('.pgProduct .similar-items ul li');
    });
  });




  /* Global Sites - Start */
  $(function () {

    function closeSites() {
      $("#cta-nav-lang").removeClass('global_activated');
      $('#nav-lang').slideUp();
    }

    function toggleSites() {
      $("#cta-nav-lang").toggleClass('global_activated');
      $('#nav-lang').slideToggle();
      if ($("#cta-nav-lang").hasClass('global_activated')) {
        setTimeout(() => {
          const sitesListLinks = document.querySelectorAll('#nav-lang a');
          sitesListLinks[0].focus();
        }, 100);
      }
    }

    function closeNav() {
      $("#btn-main-nav").removeClass('activated');
      $("#btn-main-nav").addClass('inactive');
      if ($(window).width() < 768) {
        $('ul.top-nav').slideUp();
      }
    }

    function toggleNav() {
      $("#cta-nav-lang").removeClass('global_activated');
      $("#btn-main-nav").toggleClass('activated inactive');
      $('ul.top-nav').slideToggle('fast');
    }

    function blurCloseSites(event) {
      if ($('#cta-nav-lang').hasClass('global_activated')) {
        const currentParentID = event.srcElement.offsetParent ? event.srcElement.offsetParent.id : null;
        let nextFocusParentID = null;
        if (event.relatedTarget) {
          nextFocusParentID = event.relatedTarget.offsetParent ? event.relatedTarget.offsetParent.id : null
        }
        if (currentParentID !== nextFocusParentID) {
          closeSites();
        }
      }
    }

    function showHideSites(event) {
      event.stopImmediatePropagation();
      closeNav();
      toggleSites();
      if ($('#cta-nav-lang').hasClass('global_activated')) {
        const sitesListLinks = document.querySelectorAll('#nav-lang a');
        sitesListLinks.forEach((el) => {
          el.addEventListener('blur', blurCloseSites);
        });
      };
    }

    $('#cta-nav-lang').on('mousedown', showHideSites);
    $('#cta-nav-lang').on('keydown', (event) => {
      if (event.key === 'Enter') {
        showHideSites(event);
      }
    });

    $("#btn-main-nav").on('click', function (event) {
      event.stopImmediatePropagation();
      closeSites();
      toggleNav();
    });

    $(function () {
      $("#btn-left-nav").on('click', function (event) {
        $(this).toggleClass('leftnav-inactive leftnav-active').next().toggle('fast');
      });
    });
  });
  /* Global Sites - End */

  /* Promo Headers - */
  (function ($) {
    $.fn.flowtype = function (options) {
      var settings = $.extend({
        maximum: 9999,
        minimum: 1,
        maxFont: 9999,
        minFont: 1,
        fontRatio: 35
      }, options),
        changes = function (el) {
          var $el = $(el),
            elw = $el.width(),
            width = elw > settings.maximum ? settings.maximum : elw < settings.minimum ? settings.minimum : elw,
            fontBase = width / settings.fontRatio,
            fontSize = fontBase > settings.maxFont ? settings.maxFont : fontBase < settings.minFont ? settings.minFont : fontBase;
          $el.css('font-size', fontSize + 'px');
        };

      return this.each(function () {
        var that = this;
        $(window).on('resize', function () { changes(that); });
        changes(this);
      });
    };
  }(jQuery));
  $('.top-promo').flowtype({
    minimum: 420,
    maximum: 1100,
    minFont: 16,
    maxFont: 35,
    fontRatio: 35
  });
  $('.subpgLaboratoire .free-shipping-promo').flowtype({
    minimum: 420,
    maximum: 1100,
    minFont: 10,
    maxFont: 26,
    fontRatio: 35
  });
  //	
  (function (a) {
    (jQuery.browser = jQuery.browser || {}).mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))
  })(navigator.userAgent || navigator.vendor || window.opera);
  if (!jQuery.browser.mobile) {
    $("#pgHome #hp-video").html("<video autoplay muted><source src='video/stregis_frette.mp4' type='video/mp4'><source src='video/stregis-frette.webm' type='video/webm'><source src='video/stregis-frette.ogv' type='video/ogg'></video>");
  } else {
    $('video').hide();
  }
});

$(function () {
  var $dropdowns = $("#main-nav-ul .dropdown");
  var $dropdownsLinks = $("#main-nav-ul .dropdownLink");
  $dropdownsLinks.on("focus", function () {
    let $thisParent = $(this).parent();
    $dropdowns.removeClass("open");
    $dropdownsLinks.attr("aria-expanded", "false");
    $thisParent.addClass("open");
    $(this).attr("aria-expanded", "true");
  })

  let fitstNavChild = $("#main-nav-ul [role=menuitem]").first()[0];
  $(fitstNavChild).on("keydown", function (e) {
    if (e.key === 'Tab' && e.shiftKey) {
      $dropdowns.removeClass("open");
      $dropdownsLinks.attr("aria-expanded", "false");
    }
  })

  let lastNavChild = $("#main-nav-ul [role=menuitem]").last()[0];
  $(lastNavChild).on("keydown", function (e) {
    if (e.key === 'Tab') {
      $dropdowns.removeClass("open");
      $dropdownsLinks.attr("aria-expanded", "false");
    }
  })
}); 

jQuery(function () {
	//IE11 Detection
	var IE11 = !!(
		navigator.userAgent.match(/Trident/) &&
		navigator.userAgent.match(/rv[ :]11/)
	)
	if (IE11 === true) {
		$('html').addClass('IE11')
	}

	//Product Page Item description collapse and tabs
	$(function () {
		const $tabLinksWrap = $('#tabs > .tab-links')
		const $tabFirstBtn = $tabLinksWrap.find('button').eq(0)

		$('#tabs > div').hide()
		$('#tabs > div:first').show()
		$tabFirstBtn.addClass('active')

		$tabLinksWrap.on('mouseenter', 'button', function () {

			const $this = $(this)
			const $sibling = $this.siblings()

			$sibling.removeClass('active').attr({
				'tabindex': '-1',
				'aria-selected': 'false'
			})

			$this.addClass('active').attr({
				'tabindex': '0',
				'aria-selected': 'true'
			})

			var currentTab = $this.attr('aria-controls')
			$('#tabs > div').hide()
			$(`#${currentTab}`).show()

			return false
		})
	})

	$(window).on('load', function () {
		$('.item-image, .slider').flexslider({
			animation: 'slide',
			animationLoop: false,
			useCSS: false,
		})
	})
	if (document.body.classList.contains('pghome')) {
		function checkWidth() {
			var viewportWidth = document.documentElement.clientWidth
			if (viewportWidth < 768) {
			} else {
			}
		}
		checkWidth()
		window.addEventListener('resize', function () {
			checkWidth()
		})
	}
})
function videoHovering() {
	if (document.body.classList.contains('pghome')) {
		$(window).on('load', function () {
			const video = document.querySelector('.pillow-video-wrap video')
			video.addEventListener('mouseover', function (e) {
				video.play()
			})
			video.addEventListener('mouseout', function (e) {
				video.pause()
			})
		})
	}
}

function initializeTabNavigation() {
	const $tabLinksWrap = $('.swiper-container').find('.swiper-wrapper')
	const $tabFirstBtn = $tabLinksWrap.find('button').eq(0)
	const $tabs = $('#tabs > div')

	// Hide all tabs except the first one
	$tabs.hide()
	$tabs.first().show()
	$tabFirstBtn.addClass('active')

	// Add click event listener to tab buttons
	$tabLinksWrap.on('mouseenter', 'button', function () {
		const $this = $(this)
		const previousTabId = '#' + $tabLinksWrap.find('.active').attr('aria-controls')
		const previousAnchor = $(previousTabId).find('a:first-child')
		previousAnchor.attr('tabindex', '-1')

		const $sibling = $this.siblings()
		$sibling.removeClass('active').attr({
			'tabindex': '-1',
			'aria-selected': 'false'
		})

		$this.addClass('active').attr({
			'tabindex': '0',
			'aria-selected': 'true'
		})

		const currentTabId = '#' + $this.attr('aria-controls')
		const currentAnchor = $(currentTabId).find('a:first-child')
		currentAnchor.attr('tabindex', '0')

		return false
	})
}

$(function () {
	var $dropdowns = $('#main-nav .dropdown')
	var $dropdownsLinks = $('#main-nav .dropdownLink')
	let $mainNav = document.getElementById('main-navigation')
	$dropdownsLinks.on('focus', function () {
		let $thisParent = $(this).parent()
		$dropdowns.removeClass('open')
		$dropdownsLinks.attr('aria-expanded', 'false')
		$thisParent.addClass('open')
		$(this).attr('aria-expanded', 'true')
	})

	let fitstNavChild = $('#main-nav [role=menuitem]').first()[0]
	$(fitstNavChild).on('keydown', function (e) {
		if (e.key === 'Tab' && e.shiftKey) {
			$dropdowns.removeClass('open')
			$dropdownsLinks.attr('aria-expanded', 'false')
		}
	})

	let lastNavChild = $('#main-nav [role=menuitem]').last()[0]
	$(lastNavChild).on('keydown', function (e) {
		if (e.key === 'Tab') {
			$dropdowns.removeClass('open')
			$dropdownsLinks.attr('aria-expanded', 'false')
		}
	})

	document.addEventListener('click', (evt) => {
		$mainNav
		let targetEl = evt.target // clicked element
		do {
			if (targetEl === $mainNav) {
				return
			}
			targetEl = targetEl.parentNode
		} while (targetEl)
		$dropdowns.removeClass('open')
		$dropdownsLinks.attr('aria-expanded', 'false')
	})
})


  /*Fairfield Store*/
$(document).ready(function() {
  var mobile = false;
  var tablet = false;

  /* Menus*/

  function closeSearch() {
    $('div.search').hide('fast');
  }

  function toggleSites() {
      $('.global-sites li ul').fadeToggle(0);
      $('#btn_global').toggleClass('sites-active sites-inactive');
  }
  $("#closeSearch").on("click", function(e) {
      toggleSearch();
      $('#shoppingcart').trigger('focus');
    })
  function toggleTopNav() {
      $("#btn-main-nav").toggleClass('activated inactive');
      $('ul.top-nav').fadeToggle(0);
      $('body').toggleClass('menu-open');

  }

  $("body.desktop #btn_global").on('click', function() {
    if ($("div.search").not(".mobile div.search").is(":visible")) {
      closeSearch();
    } 
      toggleSites();
  });
  if(mobile || tablet){
      $("body #btn-main-nav").on('click', function() {
          $("#btn-search").addClass('search-inactive').removeClass('search-active');
          closeSearch();
      });
  }

function toggleSearch() {
  $('#btn-search').toggleClass('search-active search-inactive').next().slideToggle('fast');
  if ($("#btn-search").hasClass('search-active')) {
    setTimeout(() => {
      const searchMenuFocusableEl = document.querySelectorAll('#tSearchContainer [data-ada-focusable="true"]');
      searchMenuFocusableEl[0].focus();
    }, 100);
  }
}

function blurCloseSearch(event) {
  if ($('#btn-search').hasClass('search-active')) { 
    const currentParentID = event.srcElement.offsetParent ? event.srcElement.offsetParent.id : null;
    let nextFocusParentID = null;
    if (event.relatedTarget) {
      nextFocusParentID = event.relatedTarget.offsetParent ? event.relatedTarget.offsetParent.id : null
    }
    if (currentParentID !== nextFocusParentID) {
      toggleSearch(); 
    }
  }
}
function showHideSearch () {
  if ($('.global-sites #btn_global').hasClass('sites-active')) { toggleSites() }
  //if( $('#btn-search').hasClass('search-active') ){ toggleSearch() }
  if ($('#btn-main-nav').hasClass('activated')) { toggleTopNav() }
  if ($('#btn-left-nav').hasClass('leftnav-active')) { toggleLeftNav() }
  toggleSearch();
  if( $('#btn-search').hasClass('search-active') ){ 
    const searchMenuFocusableEl = document.querySelectorAll('#tSearchContainer [data-ada-focusable="true"]');
    searchMenuFocusableEl.forEach((el) => {
      el.addEventListener('blur', blurCloseSearch);
    });
  }
}

$('#btn-search').on('mousedown', showHideSearch);
$('#btn-search').on('keydown', (event) => {
if (event.key === 'Enter') {
  showHideSearch();
}
});

function showHideAccount () {
  if ($('.global-sites #btn_global').hasClass('sites-active')) { toggleSites() }
  if( $('.search-trigger').hasClass('active') ){ toggleSearch() }
  if ($('#btn-main-nav').hasClass('activated')) { toggleMainNav() }
  if ($('#btn-left-nav').hasClass('leftnav-active')) { toggleLeftNav() }
  //if (accountWrapper.hasClass('active')) { toggleAccount() }
  toggleAccount();
  if( accountWrapper.hasClass('active') ){ 
      const acoountMenuFocusableEl = document.querySelectorAll('#hdrAccountWrapper [data-ada-focusable="true"]');
      acoountMenuFocusableEl.forEach((el) => {
          el.addEventListener('blur', blurCloseAccount);
      });
  }
}

$('#hdrAccountWrapper').on('click', showHideAccount);
$('#hdrAccountWrapper').on('keydown', (event) => {
  if (event.key === 'Enter') {
      showHideAccount();
  }
});

});
function buttonUp() {
  var inputVal = $('.search input[type="search"]').val();
  inputVal = inputVal.trim().length;
  if (inputVal !== 0) {
      $('.icon-search').css('display', 'none');
  } else {
      $('.search input[type="search"]').val('');
      $('.icon-search').css('display', 'block');
  }
}
